import  {Component} from 'react';
import axios from "axios";
import {headers ,apiConfigs } from '../configs';

class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 10000;
    }
    //Splash Page
    start = () => {
        return axios.get( `application/start`, {
            headers
        })
            .then(response => {
               return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    // Login Page
    sendOTP = (request) =>{
       return  axios.post( 'users/send/otp', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    // Verify Page
    loginWithOTP = (mobile,otp,push_id) => {
        return  axios.post( 'users/login/otp', {mobile , otp,push_id}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    updateProfile = (request) => {
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'bearer ' + window.localStorage.getItem("token")
        }
        return  axios.post( 'users/update', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {

                throw error;
            });
    }

    updatePosition = (request) => {
        return  axios.post( 'users/addresses/position/update', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {

                throw error;
            });
    }

    usualContent = (content) => {
        return axios.get( `application/usual/` + content, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    index = () => {
        return axios.get( `application/index/` , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    profile = (id = '') => {
        return axios.get( `users/profile/${id}` , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    provinces = (country_id) => {
        return axios.get( `locations/provinces/` + country_id , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    cities = (province_id) => {
        return axios.get( `locations/cities/` + province_id , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    setAvailability = (date) => {
        return  axios.post( 'transport/workshifts/set_availability', {date}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    RemoveAvailability = (date) => {
        return  axios.post( 'transport/workshifts/remove_availability', {date}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    GetAvailability = (date) => {
        return  axios.post( 'transport/workshifts/get_availability', {date}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    GetWorkdays = () => {
        return  axios.get( 'transport/workshifts/get_workdays',  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    requests = (request = null) => {
        return axios.post( `transport/requests/mine`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    setDriver = (request = null) => {
        return axios.post( `transport/requests/set-driver`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    setStatus = (request = null) => {
        return axios.post( `transport/requests/set-status`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    request = (request_id) => {
        return axios.get( `transport/requests/profile/${request_id}`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    finishRequest = (request_id) => {
        return axios.get( `transport/requests/finish/${request_id}`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    // Set Token

    setPushToken = (request ) => {

        return axios.post( `users/set/firebase/token`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getStatuses = () => {

        return axios.get( `transport/requests/statuses`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getDrivers = (request ) => {

        return axios.post( `users/drivers`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    setDescription = (request ) => {

        return axios.post( `transport/requests/update-description`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    setPrice = (request ) => {

        return axios.post( `transport/requests/update-price`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    walletTransactions = () => {

        return axios.get( `wallet/transactions/` , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    callDriverPosition = (driver_id) => {

        return axios.get( `transport/call-driver-position/${driver_id}` , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

}
const API = new Api();
export default API;